import { FC, ReactNode } from "react";

interface Props {
  /** Stock status, on the left. */
  status: ReactNode;
  /** Price, on the right. */
  price: ReactNode;
}

/**
 * Stock status and price on one row, sized by their content. On a narrow card the price wraps
 * to its own line, right-aligned, instead of being cut off: "1.900,00 RSD" does not fit the
 * fixed third of a column that the cards used to give it on phones.
 */
export const PriceRow: FC<Props> = ({ status, price }) => (
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      alignItems: "flex-start",
      columnGap: 8,
      padding: 5,
    }}
  >
    <div style={{ flex: "1 1 auto" }}>{status}</div>
    <div className="ion-text-right" style={{ marginLeft: "auto" }}>
      {price}
    </div>
  </div>
);
